import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { marketService } from 'shared/src/api';

export const useMarketCouponList = (marketId: number) => {
  return useSuspenseQuery({
    queryKey: queryKey.marketCoupon(marketId),
    queryFn: () => marketService.getMarketCouponList(marketId),
  });
};
